import { z } from 'zod';
import { RetentionCohortOperatorKey } from './graphqlSchema';

export const zRetentionCohortOperatorKey = z.nativeEnum(
  RetentionCohortOperatorKey,
);
